<script setup>
import { usePromotionStore } from '~/stores/promotion'
import BaseHeader from '~/components/BaseHeader'
import BaseImg from '~/components/BaseImg'

const promotionStore = usePromotionStore()
const landingPage = computed(() => promotionStore.landingPage)
const color = computed(() => landingPage.value.textForegroundColor || '#fff')
const logoColor = computed(() => (color.value === '#000000' ? '#000' : '#fff'))

const {
  headerLogoLargeImageUrl,
  headerLogoMediumImageUrl,
  headerLogoSmallImageUrl
} = landingPage.value

const sources = [
  {
    key: 'lg',
    media: '(min-width: 1024px)',
    props: {
      src: headerLogoLargeImageUrl,
      mode: 'contain',
      width: 450,
      height: 200,
      density: '2x'
    }
  },
  {
    key: 'md',
    media: '(min-width: 768px)',
    props: {
      src: headerLogoMediumImageUrl || headerLogoLargeImageUrl,
      mode: 'contain',
      width: 400,
      height: 150,
      density: '2x'
    }
  },
  {
    key: 'sm',
    media: '(min-width: 576px)',
    props: {
      src: headerLogoSmallImageUrl || headerLogoLargeImageUrl,
      width: 350,
      height: 100,
      mode: 'contain',
      density: '2x'
    }
  }
]
</script>

<template>
  <BaseHeader
    :is-default="false"
    :default-logo="false"
    :backdrop="
      landingPage.headerBackgroundSmallImageUrl ||
      landingPage.headerBackgroundLargeImageUrl
    "
    :src-per-size="landingPage"
    :color="logoColor"
    class="mb-24 mb-md-40"
  >
    <div
      :class="[
        'text-center pt-8 pb-40 pt-lg-0 pb-lg-72',
        { 'content--with-logo': landingPage.headerLogoLargeImageUrl }
      ]"
    >
      <BaseImg
        v-if="landingPage.headerLogoLargeImageUrl"
        :src="
          landingPage.headerLogoSmallImageUrl ||
          landingPage.headerLogoLargeImageUrl
        "
        :sources="sources"
        :min-width="300"
        :min-height="50"
        default-mode="contain"
        class="mb-32 mb-lg-48 d-inline-block"
      />
      <div class="container">
        <h1 class="mb-md-8" :style="{ color }">
          {{ landingPage.headerTitle }}
        </h1>
        <p
          v-if="landingPage.headerSubtitle"
          :style="{ color }"
          class="text-large mb-0"
        >
          {{ landingPage.headerSubtitle }}
        </p>
      </div>
    </div>
  </BaseHeader>
</template>

<style lang="scss" scoped>
.content--with-logo {
  min-height: 250px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

:deep(.header-container) {
  height: 49px;
}

@include media-breakpoint-up(sm) {
  .content--with-logo {
    min-height: 400px;
  }
}

@include media-breakpoint-up(lg) {
  .content--with-logo {
    min-height: 500px;
  }
}

:deep(.header-container) {
  @include media-breakpoint-up(lg) {
    height: 82px;
  }
}
</style>
